import ProductEditor from './ProductEditor.vue';

export default ProductEditor;
